import { FormatWidth, KeyValue } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComparatorElectric } from 'src/app/components/account/models/ComparatorElectric';
import { ComparatorGas } from 'src/app/components/account/models/ComparatorGas';
import { CityDetail, CountyDetailsElectricity, CountyDetailsGas } from 'src/app/components/account/models/CountyDetails';
import { GasComparatorResult } from 'src/app/components/account/models/GasComparatorResult';
import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ElectricComparatorResult } from 'src/app/components/account/models/ElectricComparatorResult';
import { DatePipe } from '@angular/common'
import { FinalClientService } from 'src/app/components/account/services/final-client.service';
import { ActivatedRoute } from '@angular/router';
import { CountyDTO } from 'src/app/components/shared/models/CountyDTO';
import { CityDTO } from 'src/app/components/shared/models/CityDTO';
import { mergeMap, tap } from 'rxjs/operators';
import { AddressService } from 'src/app/components/shared/services/address.service';
import { PlaceDetailsElectricity } from 'src/app/components/account/models/PlaceDetailsElectricity';
import { PlaceDetailsGas } from 'src/app/components/account/models/PlaceDetailsGas';
import { PublicComparatorService } from "./services/public.comparator.service";
import moment from 'moment';
import { Subscription } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import {FeignComparatorService} from "./services/feign.comparator.service";

const NATURAL_GAS_SUPPLY_COMPARISON: string = "Comparator oferte-tip de furnizare a gazelor naturale";
const NATURAL_ELECTRICITY_SUPPLY_COMPARISON: string = "Comparator oferte-tip de furnizare a energiei electrice";

export enum NaturalGasSupplyMandatoryCriteriaEnum {
  FINAL_CLIENT_TYPE = 'Tipul de client final',
  CONNECTION_METHOD = 'Modalitatea de racordare',
  ANNUAL_CONSUMPTION_CATEGORY = "Categoria de consum anual",
  UNIT_SUPPLY_PRICE_TYPE = "Tipul pretului unitar de furnizare",
  COUNTY = "Judet",
  CITY = "Localitate"
}

export enum NaturalGasSupplyAdditionalCriteriaEnum {
  OFFER_DATE = "Data de la care se aplica oferta",
  OFFER_TYPE = "Tipul ofertei",
  GAS_PRICE_TYPE = 'Tipul pretului gazelor naturale din oferta',
  SUBSCRIPTION = "Componenta fixa (abonamentul) lei/zi",
  INVOICE_FREQUENCY = "Frecventa emitere factura",
  PAYMENT_TERM = "Termen de plata",
  CONTRACT_DURATION = "Durata contractului",
  GUARANTEES = "Garantii",
  CONVENTION = "Modul de transmitere al facturii"
}

export enum ElectricitySupplyMandatoryCriteriaEnum {
  CLIENT_TYPE = 'Tip client',
  OFFER_TYPE = 'Tip oferta',
  CURRENT_BILL_CONSUMPTION = "Consumul din factura curenta pentru comparatie / Consum estimat (kWh)",
  VOLTAGE_LEVEL = "Nivel tensiune",
  PRICE_TYPE = "Tip pret",
  OFFER_DATE = "Data de la care se aplica oferta",
  COUNTY = "Judet",
  CURRENT_INVOICE_VALUE = "Valoarea facturii curente pentru comparatie (lei)",
  FIXED_COMPONENT_OFFERS = "Oferte care includ componentă fixa",
  PRODUCT_TYPE = "Tip produs",
  DAY_CONSUMPTION_PERCENTAGE = "Procent consum zona de zi",
  NIGHT_CONSUMPTION_PERCENTAGE = "Procent consum zona de noapte"
}

export enum ElectricitySupplyAdditionalCriteriaEnum {
  CONVENTION = "Mod transmitere factura",
  COUNTER_READING_FREQUENCY = "Frecventa citire contor",
  RENEWABLE_ENERGY = "Energie din surse regenerabile",
  INVOICE_FREQUENCY = "Frecventa emitere factura",
  CONTRACT_DURATION = "Perioada contract"
}

export enum NaturalGasSupplyComparisonInformationCriteriaEnum {
  ESTIMATED_MONTHLY_COMSUMPTION = "Introduceţi consumul lunar estimat MWh sau kWh",
  SUPPLY_PRICE = "Introduceți prețul de furnizare din factura actuală (fără TVA) lei/MWh sau lei/kWh",
  INVOICE_SUBSCRIPTION = "Introduceți componenta fixă (abonament) din factura actuală, dacă există (lei/zi, fără TVA)"
}

@Pipe({ name: 'sanitizeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {
  }

  transform(value: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@Component({
  selector: 'app-public-comparator',
  templateUrl: './public-comparator.component.html',
  styleUrls: ['./public-comparator.component.scss'],
})
export class PublicComparatorComponent implements OnInit {
  public gasComparatorForm: FormGroup;
  public electricityComparatorForm: FormGroup;
  public cities: CityDetail[] = [];
  public title: string;
  public mandatoryCriteriaLabel: string = "Criterii obligatorii de selectie";
  public additionalCriteria: string = "Criterii suplimentare de selectie";
  public comparisonInformation: string = "Informatii pentru comparatie";
  public isEstimatedMonthlyConsumptionKwhWarningVisible: boolean = false;
  public isSupplyPriceWarningVisible: boolean = false;
  public isInvoiceSubscriptionWarningVisible: boolean = false;
  public isNaturalGasSupplyComparisonForm: boolean;
  public placeId: string;
  public clientTypePF: boolean;
  public clientTypePJ: boolean;
  public isNaturalElectricitySupplyComparisonForm: boolean;
  public options: { [key: string]: string[] };
  public formSubmitAttempt: boolean = false;
  public countiesGas: CountyDetailsGas[] = [];
  public countiesElectricity: CountyDetailsElectricity[] = [];
  public templateNameMap: Map<string, TemplateRef<any>>;
  public isConsumptionPercentageDisplayed: boolean;
  public gasSelectedConventions: any[] = ['Oricare'];

  public controlFormNameMap: Map<string, string> = new Map([
    ["FINAL_CLIENT_TYPE", "finalClientType"],
    ["CONNECTION_METHOD", "connectionMethod"],
    ["ANNUAL_CONSUMPTION_CATEGORY", "annualConsumptionCategory"],
    ["UNIT_SUPPLY_PRICE_TYPE", "unitSupplyPriceType"],
    ["COUNTY", "county"],
    ["CITY", "city"],
    ["CLIENT_TYPE", "clientType"],
    ["OFFER_TYPE", "offerType"],
    ["CURRENT_BILL_CONSUMPTION", "currentBillConsumption"],
    ["VOLTAGE_LEVEL", "voltageLevel"],
    ["PRICE_TYPE", "priceType"],
    ["OFFER_DATE", "offerDate"],
    ["CURRENT_INVOICE_VALUE", "currentInvoiceValue"],
    ["FIXED_COMPONENT_OFFERS", "fixedComponentOffers"],
    ["PRODUCT_TYPE", "productType"],
    ["DAY_CONSUMPTION_PERCENTAGE", "dayConsumptionPercentage"],
    ["NIGHT_CONSUMPTION_PERCENTAGE", "nightConsumptionPercentage"],
    ["ADDITIONAL_CRITERIA", "additionalCriteria"],
    ["GAS_PRICE_TYPE", "gasPriceType"],
    ["SUBSCRIPTION", "subscription"],
    ["INVOICE_FREQUENCY", "invoiceFrequency"],
    ["PAYMENT_TERM", "paymentTerm"],
    ["CONTRACT_DURATION", "contractDuration"],
    ["GUARANTEES", "guarantees"],
    ["CONVENTION", "convention"],
    ["COUNTER_READING_FREQUENCY", "counterReadingFrequency"],
    ["RENEWABLE_ENERGY", "renewableEnergy"],
    ["ESTIMATED_MONTHLY_COMSUMPTION_MWH", "estimatedMonthlyConsumptionMwh"],
    ["ESTIMATED_MONTHLY_COMSUMPTION_KWH", "estimatedMonthlyConsumptionKwh"],
    ["SUPPLY_PRICE_LEI_MWH", "supplyPriceLeiMwh"],
    ["SUPPLY_PRICE_LEI_KWH", "supplyPriceLeiKwh"],
    ["INVOICE_SUBSCRIPTION", "invoiceSubscriptionLeiZi"]
  ]);
  public gasComparatorResults: GasComparatorResult[];
  public electricComparatorResults: ElectricComparatorResult[];
  public comparatorType: string;
  public consumptionPlace: any;
  public county: CountyDTO;
  public city: CityDTO;
  public minDate: Date;
  public zoneId: number;
  public noResults: string = "Nu exista rezultate dupa criteriile selectate!";
  public notSelectedAllTheCriteriaMessage: string = "Nu ati selectat toate criteriile.";
  public noteFieldsMandatoryToComplete: string = 'Nota: Toate campurile marcate cu <span class="red">*</span> sunt obligatoriu de completat';
  public electricComparatorNote: string = "Tarifele reglementate pentru servicii sunt cele in vigoare la data selectata la campul \"Data de la care se aplica oferta\".";
  public messageError: string;
  public isComparatorSwitchVisible: boolean;

  public connectionModeValuesMap = new Map([
    ["Sistem de distributie", "sistem_de_distributie"],
    ["Sistem de transport", "sistem_de_transport"],
    ["Conducta de alimentare din amonte", "amonte"]
  ]);

  public consumptionCategoryValuesMap = new Map([
    ["C1 - Client cu consum anual mai mic sau egal cu 280 MWh", "b1"],
    ["C2 - Client cu consum anual intre 281 MWh si 2800 MWh", "b2"],
    ["C3 - Client cu consum anual intre 2801 MWh si 28000 MWh", "b3"],
    ["C4 - Client cu consum anual intre 28001 MWh si 280 000 MWh", "b4"],
    ["C5 - Client cu consum anual de peste 280 000 MWh", "b5"],
    ["Client cu un consum anual mai mic sau egal cu 28.000 MWh", "a1"],
    ["Client cu un consum anual de peste 28.000 MWh", "a2"]
  ]);

  public unitPriceTypeValuesMap = new Map([
    ["Cu servicii reglementate incluse", "cu_reglementate"],
    ["Fara servicii reglementate incluse", "fara_reglementate"]
  ]);

  public gasConventionTypeValuesMap = new Map([
    ["Oricare", ""],
    ["Tiparit", "tip"],
    ["Electronic", "elec"]
  ]);

  public paymentTermValuesMap = new Map([
    ["oricare", ""],
    ["mai mic sau egal cu 15 zile", "pana_15"],
    ["intre 16 si 29 zile", "15_30"],
    ["mai mare sau egal cu 30 zile", "peste_30"]
  ]);

  public offerTypeGasValuesMap = new Map([
    ["Oricare", ""],
    ["Oferta simpla", "simpla"],
    ["Oferta la pachet cu o oferta de Energie Electrica", "pachet"]
  ]);

  public electricInvoiceFrequencyValuesMap = new Map([
    ["Oricare", ""],
    ["lunar", "1"],
    ["la 2 luni", "2"],
    ["la 3 luni", "3"],
    ["altele", "4"]
  ]);

  public gasInvoiceFrequencyValuesMap = new Map([
    ["oricare", ""],
    ["lunar", "lunar"],
    ["la 2 luni", "2"],
    ["la 3 luni", "3"]
  ]);

  public fixedComponentOffersValuesMap = new Map([
    ["Oricare", ""],
    ["da", "1"],
    ["nu", "2"]
  ]);

  public offerTypeValuesMap = new Map([
    ["Oricare", "0"],
    ["Oferte concurentiale", "1"],
    ["Oferte serviciu universal", "2"]
  ]);

  public priceTypeValuesMap = new Map([
    ["Diferentiat pe zone orare", "diferentiat"],
    ["Nediferentiat", "nediferentiat"]
  ]);

  public productTypeValuesMap = new Map([
    ["Oricare", "0"],
    ["Pret fix", "1"],
    ["Pret variabil", "2"]
  ]);

  public gasPriceTypeValuesMap = new Map([
    ["Oricare", ""],
    ["Pret fix", "fix"],
    ["Pret variabil", "variabil"],
    ["Pret mixt", "mixt"],
    ["Pret variabil bazat pe preturi SPOT", "spot"],
    ["Pret variabil bazat pe preturi ANGRO", "angro"],
    ["Pret maxim", "maxim"],
    ["Pret variabil bazat pe un Index variabil", "index"]
  ]);

  public voltageLevelTypeValuesMap = new Map([
    ["Joasă tensiune", "JT_"],
    ["Medie tensiune", "MT_"],
    ["Inaltă tensiune", "IT_"]
  ]);

  public contractDurationTypeValuesMap = new Map([
    ["Oricare", ""],
    ["mai mica de 1 an", "1"],
    ["1 an", "2"],
    ["intre 1 an si 2 ani", "3"],
    ["2 ani", "4"],
    ["intre 2 ani si 3 ani", "5"],
    ["3 ani", "6"],
    ["mai mare de 3 ani", "7"],
    ["nedeterminata", "8"]
  ]);

  public gasContractDurationTypeValuesMap = new Map([
    ["oricare", ""],
    ["nedeterminata", "nedeterminata"],
    ["mai mica de 12 luni", "6"],
    ["12 luni", "12"],
    ["intre 13 si 24 luni", "24"],
    ["mai mare de 24 luni", "36"],
  ]);

  public counterReadingFrequencyTypeValuesMap = new Map([
    ["Oricare", ""],
    ["lunar", "1"],
    ["la 2 luni", "2"],
    ["la 3 luni", "3"],
    ["la 4 luni", "4"],
    ["la 5 luni", "5"],
    ["la 6 luni", "6"]
  ]);

  public renewableEnergyTypeValuesMap = new Map([
    ["Oricare", ""],
    ["da", "1"],
    ["nu", "2"]
  ]);

  public electricConventionTypeValuesMap = new Map([
    ["Oricare", ""],
    ["Posta / Curier", "1"],
    ["E-mail", "2"],
    ["Portal", "3"],
    ["Posta/curier si electronic", "4"]
  ]);

  public subscriptionValuesMap = new Map([
    ["oricare", ""],
    ["da", "da"],
    ["nu", "nu"]
  ]);

  public guaranteesValuesMap = new Map([
    ["oricare", ""],
    ["cu garantii", "cu_garantii"],
    ["fara garantii", "fara_garantii"]
  ]);

  @Input() isLoggedIn: boolean;

  @ViewChild('finalClientTypeInfo', { static: true }) finalClientTypeInfoTemplate: TemplateRef<any>;
  @ViewChild('connectionMethodInfo', { static: true }) connectionMethodInfoTemplate: TemplateRef<any>;
  @ViewChild('annualConsumptionCategoryInfo', { static: true }) annualConsumptionCategoryInfoTemplate: TemplateRef<any>;
  @ViewChild('unitSupplyPriceTypeInfo', { static: true }) unitSupplyPriceTypeInfoTemplate: TemplateRef<any>;
  @ViewChild('countyInfo', { static: true }) countyInfoTemplate: TemplateRef<any>;
  @ViewChild('cityInfo', { static: true }) cityInfoTemplate: TemplateRef<any>;
  @ViewChild('clientTypeInfo', { static: true }) clientTypeInfoTemplate: TemplateRef<any>;
  @ViewChild('offerTypeInfo', { static: true }) offerTypeInfoTemplate: TemplateRef<any>;
  @ViewChild('currentBillConsumptionInfo', { static: true }) currentBillConsumptionInfoTemplate: TemplateRef<any>;
  @ViewChild('voltageLevelInfo', { static: true }) voltageLevelInfoTemplate: TemplateRef<any>;
  @ViewChild('priceTypeInfo', { static: true }) priceTypeInfoTemplate: TemplateRef<any>;
  @ViewChild('offerDateInfo', { static: true }) offerDateInfoTemplate: TemplateRef<any>;
  @ViewChild('currentInvoiceValueInfo', { static: true }) currentInvoiceValueInfoTemplate: TemplateRef<any>;
  @ViewChild('fixedComponentOffersValueInfo', { static: true }) fixedComponentOffersValueInfoTemplate: TemplateRef<any>;
  @ViewChild('productTypeInfo', { static: true }) productTypeInfoTemplate: TemplateRef<any>;
  @ViewChild('additionalCriteriaInfo', { static: true }) additionalCriteriaInfoTemplate: TemplateRef<any>;
  @ViewChild('gasPriceTypeInfo', { static: true }) gasPriceTypeInfoTemplate: TemplateRef<any>;
  @ViewChild('subscriptionInfo', { static: true }) subscriptionInfoTemplate: TemplateRef<any>;
  @ViewChild('invoiceFrequencyInfo', { static: true }) invoiceFrequencyInfoTemplate: TemplateRef<any>;
  @ViewChild('paymentTermInfo', { static: true }) paymentTermInfoTemplate: TemplateRef<any>;
  @ViewChild('contractDurationInfo', { static: true }) contractDurationInfoTemplate: TemplateRef<any>;
  @ViewChild('guaranteesInfo', { static: true }) guaranteesInfoTemplate: TemplateRef<any>;
  @ViewChild('conventionInfo', { static: true }) conventionInfoTemplate: TemplateRef<any>;
  @ViewChild('counterReadingFrequencyInfo', { static: true }) counterReadingFrequencyInfoTemplate: TemplateRef<any>;
  @ViewChild('renewableEnergyInfo', { static: true }) renewableEnergyInfoTemplate: TemplateRef<any>;
  @ViewChild('comparisonInformationInfo', { static: true }) comparisonInformationInfoTemplate: TemplateRef<any>;
  @ViewChild('estimatedMonthlyConsumptionInfo', { static: true }) estimatedMonthlyConsumptionInfoTemplate: TemplateRef<any>;
  @ViewChild('gasPriceTypeOption1Info', { static: true }) gasPriceTypeOption1InfoTemplate: TemplateRef<any>;
  @ViewChild('gasPriceTypeOption2Info', { static: true }) gasPriceTypeOption2InfoTemplate: TemplateRef<any>;
  @ViewChild('gasPriceTypeOption3Info', { static: true }) gasPriceTypeOption3InfoTemplate: TemplateRef<any>;
  @ViewChild('gasPriceTypeOption4Info', { static: true }) gasPriceTypeOption4InfoTemplate: TemplateRef<any>;
  @ViewChild('gasPriceTypeOption5Info', { static: true }) gasPriceTypeOption5InfoTemplate: TemplateRef<any>;
  @ViewChild('gasPriceTypeOption6Info', { static: true }) gasPriceTypeOption6InfoTemplate: TemplateRef<any>;
  @ViewChild('gasPriceTypeOption7Info', { static: true }) gasPriceTypeOption7InfoTemplate: TemplateRef<any>;
  @ViewChild('offerTypeOption2Info', { static: true }) offerTypeOption2InfoTemplate: TemplateRef<any>;
  @ViewChild('gasComparatorDetail', { static: true }) gasComparatorDetailTemplate: TemplateRef<any>;

  private subscriptions: Subscription[] = [];

  public originalOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
    return 0;
  }

  constructor(private datepipe: DatePipe, private formBuilder: FormBuilder,
    private publicComparatorService: FeignComparatorService,
    private finalClientService: FinalClientService,
    private addressService: AddressService,
    private route: ActivatedRoute,
    private keycloakService: KeycloakService
  ) {
    this.options = {};
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
    this.messageError = "";
  }

  ngOnInit(): void {
    this.keycloakService.isLoggedIn().then((result: boolean) => {
      this.isLoggedIn = result;
      this.isComparatorSwitchVisible = !this.isLoggedIn;
    });

    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.comparatorType = params['comparatorType'] || 'gas';
      this.placeId = params['placeId'];
      this.clientTypePF = params['clientTypePF'];
      this.clientTypePJ = params['clientTypePJ'];

      this.initTemplateNameMap();
      this.handleComparatorType(this.comparatorType);
      this.handlePlaceIdAndComparatorType();
      this.handleClientType();
    }));
  }

  private handleComparatorType(comparatorType: string): void {
    switch (comparatorType) {
      case 'electric':
        this.onNaturalElectricitySupplyComparisonFormSwitch();
        break;
      case 'gas':
      default:
        this.onNaturalGasSupplyComparisonFormSwitch();
    }
  }

  private handleGasComparator(): void {
    this.subscriptions.push(
      this.publicComparatorService.getCountiesGas().pipe(
        tap((counties: CountyDetailsGas[]) => {
          this.countiesGas = counties;
        }),
        mergeMap(() => this.finalClientService.getFCGasConsumptionPlace(+this.placeId).pipe(
          tap((placeDetailsGas: PlaceDetailsGas) => this.consumptionPlace = placeDetailsGas)
        )),
        mergeMap((placeDetailsGas: PlaceDetailsGas) => this.addressService.getCounty(placeDetailsGas.county))
      ).subscribe((county: CountyDTO) => {
        this.county = county;
        let countyGas: CountyDetailsGas = this.countiesGas.find(x => x.nume.toUpperCase() === this.county.name.toUpperCase());
        if (countyGas) {
          this.comparatorForm.get('county')?.setValue(countyGas.id_judet);
          this.comparatorForm.get('county')?.disable();
        }
        this.subscriptions.push(this.publicComparatorService.getCities(countyGas.nume.toUpperCase())
          .subscribe((cities: CityDetail[]) => {
            if (Array.isArray(cities)) {
              cities.forEach(city => this.cities.push(city));
            } else {
              this.cities.push(cities);
            }
            let cityGas = this.cities.find(city => city.localitate_apartinatoare && city.localitate_apartinatoare.toUpperCase() === this.consumptionPlace.cityName && this.consumptionPlace.cityName.toUpperCase() ||
              city.localitate_principala.toUpperCase() === this.consumptionPlace.cityName && this.consumptionPlace.cityName.toUpperCase());
            if (cityGas) {
              this.comparatorForm.get('city')?.setValue(cityGas.siruta);
              this.comparatorForm.get('city')?.disable();
            }
          }));
      })
    );
  }

  private handleElectricComparator(): void {
    this.subscriptions.push(
      this.publicComparatorService.getCountiesElectricity().pipe(
        tap((counties: CountyDetailsElectricity[]) => {
          this.countiesElectricity = counties;
        }),
        mergeMap(() => this.finalClientService.getFCElectricityConsumptionPlace(+this.placeId).pipe(
          tap((placeDetailsElectricity: PlaceDetailsElectricity) => this.consumptionPlace = placeDetailsElectricity)
        )),
        mergeMap((placeDetailsElectricity: PlaceDetailsElectricity) => this.addressService.getCounty(placeDetailsElectricity.county))
      ).subscribe((county: CountyDTO) => {
        this.county = county;
        let countyElectricity: CountyDetailsElectricity = this.countiesElectricity.find(x => x.nume.toUpperCase() === this.county.name.toUpperCase());
        this.zoneId = this.countiesElectricity.find(county => county.id_judet == countyElectricity.id_judet).id_zona;
        if (countyElectricity) {
          this.comparatorForm.get('county')?.setValue(countyElectricity.id_judet);
          this.comparatorForm.get('county').disable();
        }
      })
    );
  }

  private handlePlaceIdAndComparatorType(): void {
    if (this.placeId) {
      if (this.comparatorType === "gas") {
        this.handleGasComparator();
      } else if (this.comparatorType === "electric") {
        this.handleElectricComparator();
      }
      localStorage.setItem('consumptionPlace', JSON.stringify(this.consumptionPlace));
    }
  }

  private handleClientType(): void {
    if (this.clientTypePF) {
      if (this.isNaturalElectricitySupplyComparisonForm) {
        this.comparatorForm.get('clientType').setValue(this.options["CLIENT_TYPE"][0]);
        this.comparatorForm.get('clientType').disable();
      } else {
        this.comparatorForm.get('finalClientType').setValue(this.options["FINAL_CLIENT_TYPE"][0]);
        this.comparatorForm.get('finalClientType').disable();
      }
    }
    if (this.clientTypePJ) {
      if (this.isNaturalElectricitySupplyComparisonForm) {
        this.comparatorForm.get('clientType').setValue(this.options["CLIENT_TYPE"][1]);
        this.comparatorForm.get('clientType').disable();
      } else {
        this.comparatorForm.get('finalClientType').setValue(this.options["FINAL_CLIENT_TYPE"][1]);
        this.comparatorForm.get('finalClientType').disable();
      }
    }
  }

  initTemplateNameMap(): void {
    this.templateNameMap = new Map([
      ["FINAL_CLIENT_TYPE", this.finalClientTypeInfoTemplate],
      ["CONNECTION_METHOD", this.connectionMethodInfoTemplate],
      ["ANNUAL_CONSUMPTION_CATEGORY", this.annualConsumptionCategoryInfoTemplate],
      ["UNIT_SUPPLY_PRICE_TYPE", this.unitSupplyPriceTypeInfoTemplate],
      ["COUNTY", this.countyInfoTemplate],
      ["CITY", this.cityInfoTemplate],
      ["CLIENT_TYPE", this.clientTypeInfoTemplate],
      ["OFFER_TYPE", this.offerTypeInfoTemplate],
      ["OFFER_DATE", this.offerDateInfoTemplate],
      ["CURRENT_BILL_CONSUMPTION", this.currentBillConsumptionInfoTemplate],
      ["VOLTAGE_LEVEL", this.voltageLevelInfoTemplate],
      ["PRICE_TYPE", this.priceTypeInfoTemplate],
      ["CURRENT_INVOICE_VALUE", this.currentInvoiceValueInfoTemplate],
      ["FIXED_COMPONENT_OFFERS", this.fixedComponentOffersValueInfoTemplate],
      ["PRODUCT_TYPE", this.productTypeInfoTemplate],
      ["ADDITIONAL_CRITERIA", this.additionalCriteriaInfoTemplate],
      ["GAS_PRICE_TYPE", this.gasPriceTypeInfoTemplate],
      ["SUBSCRIPTION", this.subscriptionInfoTemplate],
      ["INVOICE_FREQUENCY", this.invoiceFrequencyInfoTemplate],
      ["PAYMENT_TERM", this.paymentTermInfoTemplate],
      ["CONTRACT_DURATION", this.contractDurationInfoTemplate],
      ["GUARANTEES", this.guaranteesInfoTemplate],
      ["CONVENTION", this.conventionInfoTemplate],
      ["COUNTER_READING_FREQUENCY", this.counterReadingFrequencyInfoTemplate],
      ["RENEWABLE_ENERGY", this.renewableEnergyInfoTemplate],
      ["COMPARISON_INFORMATION", this.comparisonInformationInfoTemplate],
      ["ESTIMATED_MONTHLY_COMSUMPTION", this.estimatedMonthlyConsumptionInfoTemplate],
      ["gasPriceTypeOption1", this.gasPriceTypeOption1InfoTemplate],
      ["gasPriceTypeOption2", this.gasPriceTypeOption2InfoTemplate],
      ["gasPriceTypeOption3", this.gasPriceTypeOption3InfoTemplate],
      ["gasPriceTypeOption4", this.gasPriceTypeOption4InfoTemplate],
      ["gasPriceTypeOption5", this.gasPriceTypeOption5InfoTemplate],
      ["gasPriceTypeOption6", this.gasPriceTypeOption6InfoTemplate],
      ["gasPriceTypeOption7", this.gasPriceTypeOption7InfoTemplate],
      ["offerTypeOption2", this.offerTypeOption2InfoTemplate]
    ]);
  }

  getCountiesElectricity(): void {
    this.countiesElectricity = [];
    this.subscriptions.push(this.publicComparatorService.getCountiesElectricity().subscribe(
      (counties: CountyDetailsElectricity[]) => {
        this.countiesElectricity = counties;
      }));
  }

  getCountiesGaz(): void {
    this.countiesGas = [];
    this.subscriptions.push(this.publicComparatorService.getCountiesGas().subscribe(
      (counties: CountyDetailsGas[]) => {
        this.countiesGas = counties;
      }));
  }

  onChangeConnectionMethod(clieconnectionMethod: string): void {
    if (clieconnectionMethod === "Sistem de distributie") {
      this.options["ANNUAL_CONSUMPTION_CATEGORY"] = [
        "C1 - Client cu consum anual mai mic sau egal cu 280 MWh",
        "C2 - Client cu consum anual intre 281 MWh si 2800 MWh",
        "C3 - Client cu consum anual intre 2801 MWh si 28000 MWh",
        "C4 - Client cu consum anual intre 28001 MWh si 280 000 MWh",
        "C5 - Client cu consum anual de peste 280 000 MWh"];
    } else {
      this.options["ANNUAL_CONSUMPTION_CATEGORY"] = [
        "Client cu un consum anual mai mic sau egal cu 28.000 MWh",
        "Client cu un consum anual de peste 28.000 MWh"];
    }
    this.comparatorForm.get('annualConsumptionCategory')?.setValue(this.options["ANNUAL_CONSUMPTION_CATEGORY"][0]);
  }

  onGetCitiesByCounty(countyId: number): void {
    let countyName: string;
    if (this.isNaturalGasSupplyComparisonForm) {
      countyName = this.countiesGas.find(county => county.id_judet == countyId).nume.toUpperCase();
      this.cities = [];
      this.subscriptions.push(this.publicComparatorService.getCities(countyName).subscribe(
        (cities: CityDetail[]) => {
          if (Array.isArray(cities)) {
            cities.forEach(city => this.cities.push(city));
          } else {
            this.cities.push(cities);
          }
          this.comparatorForm.get('city')?.setValue(this.cities[0].siruta);
        }));
    } else {
      this.zoneId = this.countiesElectricity.find(county => county.id_judet == countyId).id_zona;
    }
  }

  initGasOptions(): void {
    this.options = {};
    this.options["FINAL_CLIENT_TYPE"] = ["Casnic", "Noncasnic"]
    this.options["CONNECTION_METHOD"] = ["Sistem de distributie", "Sistem de transport", "Conducta de alimentare din amonte"];
    this.options["ANNUAL_CONSUMPTION_CATEGORY"] = [
      "C1 - Client cu consum anual mai mic sau egal cu 280 MWh",
      "C2 - Client cu consum anual intre 281 MWh si 2800 MWh",
      "C3 - Client cu consum anual intre 2801 MWh si 28000 MWh",
      "C4 - Client cu consum anual intre 28001 MWh si 280 000 MWh",
      "C5 - Client cu consum anual de peste 280 000 MWh"];
    this.options["UNIT_SUPPLY_PRICE_TYPE"] = ["Cu servicii reglementate incluse", "Fara servicii reglementate incluse"];
    this.options["GAS_PRICE_TYPE"] = ["Oricare", "Pret fix", "Pret variabil", "Pret mixt", "Pret variabil bazat pe preturi SPOT",
      "Pret variabil bazat pe preturi ANGRO", "Pret maxim", "Pret variabil bazat pe un Index variabil"];
    this.options["OFFER_TYPE"] = ["Oricare", "Oferta simpla", "Oferta la pachet cu o oferta de Energie Electrica"];
    this.options["CONVENTION"] = ["Oricare", "Tiparit", "Electronic"];
    this.options["SUBSCRIPTION"] = ["oricare", "da", "nu"];
    this.options["INVOICE_FREQUENCY"] = ["oricare", "lunar", "la 2 luni", "la 3 luni"];
    this.options["PAYMENT_TERM"] = ["oricare", "mai mic sau egal cu 15 zile", "intre 16 si 29 zile", "mai mare sau egal cu 30 zile"];
    this.options["CONTRACT_DURATION"] = ["oricare", "nedeterminata", "mai mica de 12 luni", "12 luni", "intre 13 si 24 luni", "mai mare de 24 luni"];
    this.options["GUARANTEES"] = ["oricare", "cu garantii", "fara garantii"];
    for (let option in this.options) {
      switch (option) {
        case "CONVENTION":
          break;
        default:
          this.comparatorForm.get(this.controlFormNameMap.get(option))?.setValue(this.options[option][0]);
          break;
      }
    }

    this.gasComparatorForm.get('estimatedMonthlyConsumptionMwh')?.setValue(1);
    this.isEstimatedMonthlyConsumptionKwhWarningVisible = false;
    this.isSupplyPriceWarningVisible = false;
    this.isInvoiceSubscriptionWarningVisible = false;
  }

  initElectricityOptions(): void {
    this.options = {};
    this.options["CLIENT_TYPE"] = ["Casnic", "Noncasnic"];
    this.options["OFFER_TYPE"] = ["Oricare", "Oferte concurentiale", "Oferte serviciu universal"];
    this.options["FIXED_COMPONENT_OFFERS"] = ["Oricare", "da", "nu"];
    this.options["PRICE_TYPE"] = ["Nediferentiat", "Diferentiat pe zone orare"];
    this.options["PRODUCT_TYPE"] = ["Oricare", "Pret fix", "Pret variabil"];
    this.options["CONVENTION"] = ["Oricare", "Posta / Curier", "E-mail", "Portal", "Posta/curier si electronic"];
    this.options["COUNTER_READING_FREQUENCY"] = ["Oricare", "lunar ", "la 2 luni", "la 3 luni", "la 4 luni", "la 5 luni", "la 6 luni"];
    this.options["RENEWABLE_ENERGY"] = ["Oricare", "da", "nu"];
    this.options["INVOICE_FREQUENCY"] = ["Oricare", "lunar", "la 2 luni", "la 3 luni", "altele"];
    this.options["CONTRACT_DURATION"] = ["Oricare", "mai mica de 1 an", "1 an", "intre 1 an si 2 ani", "2 ani", "intre 2 ani si 3 ani", "3 ani",
      "mai mare de 3 ani", "nedeterminata"];
    for (let option in this.options) {
      this.comparatorForm.get(this.controlFormNameMap.get(option))?.setValue(this.options[option][0]);
    }
  }

  onCriteriaInfoMouseOver(mandatoryCriteriaTemplateElement: HTMLElement, index: number): void {
    mandatoryCriteriaTemplateElement.style.display = "block";
    if ((index + 1) % 3 === 0) {
      mandatoryCriteriaTemplateElement.classList.add("toolTipLeft");
    }
  }

  onCriteriaInfoMouseLeave(mandatoryCriteriaTemplateElement: HTMLElement): void {
    mandatoryCriteriaTemplateElement.style.display = "none";
  }

  initGasComparatorForm(): void {
    this.gasComparatorForm = this.formBuilder.group({
      finalClientType: new FormControl('', [Validators.required]),
      connectionMethod: ['', [Validators.required]],
      annualConsumptionCategory: ['', [Validators.required]],
      county: ['', [Validators.required]],
      offerDate: [moment().format('YYYY-MM-DD'), [Validators.required]],
      offerType: ['', [Validators.required]],
      city: ['', [Validators.required]],
      unitSupplyPriceType: ['', [Validators.required]],
      gasPriceType: ['', [Validators.required]],
      subscription: [''],
      paymentTerm: ['', [Validators.required]],
      guarantees: ['', [Validators.required]],
      convention: new FormArray([]),
      estimatedMonthlyConsumptionMwh: [''],
      estimatedMonthlyConsumptionKwh: [''],
      supplyPriceLeiMwh: [''],
      supplyPriceLeiKwh: [''],
      contractDuration: ['', [Validators.required]],
      invoiceSubscriptionLeiZi: [''],
      invoiceFrequency: ['']
    });
    this.onEstimatedMonthlyConsumptionMwhValueChangesSubscribe();
    this.onEstimatedMonthlyConsumptionKwhValueChangesSubscribe();
    this.onSupplyPriceLeiKwhValueChangesSubscribe();
    this.onSupplyPriceLeiMwhValueChangesSubscribe();
    this.onFinalClientTypeValueChangesSubscribe();

  }

  onEstimatedMonthlyConsumptionMwhValueChangesSubscribe(): void {
    this.subscriptions.push(this.gasComparatorForm.controls['estimatedMonthlyConsumptionMwh'].valueChanges.subscribe(value => {
      value = value.toString().replace(",", ".");
      this.gasComparatorForm.get('estimatedMonthlyConsumptionMwh')?.setValue(value, { onlySelf: true, emitEvent: false });
      if (value !== '') {
        value = parseFloat(value) * 1000;
        if (value > 0) {
          this.gasComparatorForm.get('estimatedMonthlyConsumptionKwh')?.setValue(value, { onlySelf: true, emitEvent: false });
        }
      } else {
        this.gasComparatorForm.get('estimatedMonthlyConsumptionKwh')?.setValue('', { onlySelf: true, emitEvent: false });
      }
    }));
  }

  onEstimatedMonthlyConsumptionKwhValueChangesSubscribe(): void {
    this.subscriptions.push(this.gasComparatorForm.controls['estimatedMonthlyConsumptionKwh'].valueChanges.subscribe(value => {
      value = value.toString().replace(",", ".");
      this.gasComparatorForm.get('estimatedMonthlyConsumptionKwh')?.setValue(value, { onlySelf: true, emitEvent: false });
      if (value !== '') {
        value = parseFloat(value) / 1000;
        if (value > 0) {
          this.gasComparatorForm.get('estimatedMonthlyConsumptionMwh')?.setValue(value, { onlySelf: true, emitEvent: false });
        }
      } else {
        this.gasComparatorForm.get('estimatedMonthlyConsumptionMwh')?.setValue('', { onlySelf: true, emitEvent: false });
      }
    }));
  }

  onSupplyPriceLeiKwhValueChangesSubscribe(): void {
    this.subscriptions.push(this.gasComparatorForm.controls['supplyPriceLeiKwh'].valueChanges.subscribe(value => {
      value = value.toString().replace(",", ".");
      this.gasComparatorForm.get('supplyPriceLeiKwh')?.setValue(value, { onlySelf: true, emitEvent: false });
      if (value !== '') {
        value = parseFloat(value) * 1000;
        if (value > 0) {
          this.gasComparatorForm.get('supplyPriceLeiMwh')?.setValue(value.toFixed(4), { onlySelf: true, emitEvent: false });
        }
      } else {
        this.gasComparatorForm.get('supplyPriceLeiMwh')?.setValue('', { onlySelf: true, emitEvent: false });
      }
    }));
  }

  onSupplyPriceLeiMwhValueChangesSubscribe(): void {
    this.subscriptions.push(this.gasComparatorForm.controls['supplyPriceLeiMwh'].valueChanges.subscribe(value => {
      value = value.toString().replace(",", ".");
      this.gasComparatorForm.get('supplyPriceLeiMwh')?.setValue(value, { onlySelf: true, emitEvent: false });
      if (value !== '') {
        value = parseFloat(value) / 1000;
        if (value > 0) {
          this.gasComparatorForm.get('supplyPriceLeiKwh')?.setValue(value.toFixed(4), { onlySelf: true, emitEvent: false });
        }
      } else {
        this.gasComparatorForm.get('supplyPriceLeiKwh')?.setValue('', { onlySelf: true, emitEvent: false });
      }
    }));
  }

  onFinalClientTypeValueChangesSubscribe(): void {
    this.subscriptions.push(this.gasComparatorForm.controls['finalClientType'].valueChanges.subscribe(value => {
      if (value === "Casnic") {
        this.options["INVOICE_FREQUENCY"] = ["oricare", "lunar", "la 2 luni", "la 3 luni"];
      } else {
        this.options["INVOICE_FREQUENCY"] = ["oricare", "lunar", "la 2 luni", "la 3 luni", "la 4 luni", "la 5 luni", "la 6 luni"];
      }
      this.gasComparatorForm.get('invoiceFrequency')?.setValue(this.options["INVOICE_FREQUENCY"][0]);
    }));
  }

  initElectricityComparatorForm(): void {
    this.electricityComparatorForm = this.formBuilder.group({
      clientType: ['', [Validators.required]],
      offerType: ['', [Validators.required]],
      currentBillConsumption: [100],
      voltageLevel: ['', [Validators.required]],
      priceType: ['', [Validators.required]],
      offerDate: [moment().format('YYYY-MM-DD'), [Validators.required]],
      county: ['', [Validators.required]],
      currentInvoiceValue: [''],
      fixedComponentOffers: ['', [Validators.required]],
      productType: ['', [Validators.required]],
      dayConsumptionPercentage: [],
      nightConsumptionPercentage: [],
      convention: [''],
      counterReadingFrequency: [''],
      renewableEnergy: [''],
      invoiceFrequency: [''],
      contractDuration: ['']
    });
    this.onClientTypeValueChangesSubscribe();
    this.onPriceTypeValueChangesSubscribe();
  }

  onClientTypeValueChangesSubscribe(): void {
    this.subscriptions.push(this.comparatorForm.controls['clientType'].valueChanges.subscribe(value => {
      if (value === "Casnic") {
        this.options["VOLTAGE_LEVEL"] = ["Medie tensiune", "Joasă tensiune"];
      } else {
        this.options["VOLTAGE_LEVEL"] = ["Inaltă tensiune", "Medie tensiune", "Joasă tensiune"];
      }
      this.comparatorForm.get('voltageLevel')?.setValue(this.options["VOLTAGE_LEVEL"][this.options["VOLTAGE_LEVEL"].length - 1]);
    }));
  }

  onPriceTypeValueChangesSubscribe(): void {
    let dayConsumptionPercentageSubscription: Subscription;
    let nightConsumptionPercentageSubscription: Subscription;
    this.subscriptions.push(this.electricityComparatorForm.controls['priceType'].valueChanges.subscribe(priceType => {
      this.isConsumptionPercentageDisplayed = priceType === this.options['PRICE_TYPE'][1];
      if (this.isConsumptionPercentageDisplayed) {
        this.comparatorForm.get(this.controlFormNameMap.get('DAY_CONSUMPTION_PERCENTAGE')).setValidators([Validators.required]);
        this.comparatorForm.get(this.controlFormNameMap.get('NIGHT_CONSUMPTION_PERCENTAGE')).setValidators([Validators.required]);
        this.onDayConsumptionPercentageSubscribe(dayConsumptionPercentageSubscription);
        this.onNightConsumptionPercentageSubscribe(nightConsumptionPercentageSubscription);
      } else {
        dayConsumptionPercentageSubscription?.unsubscribe();
        nightConsumptionPercentageSubscription?.unsubscribe();
        this.electricityComparatorForm.controls.dayConsumptionPercentage.setValue("");
        this.electricityComparatorForm.controls.nightConsumptionPercentage.setValue("");
        this.comparatorForm.get(this.controlFormNameMap.get('DAY_CONSUMPTION_PERCENTAGE')).clearValidators();
        this.comparatorForm.get(this.controlFormNameMap.get('NIGHT_CONSUMPTION_PERCENTAGE')).clearValidators();
      }
      this.comparatorForm.controls.nightConsumptionPercentage.updateValueAndValidity();
      this.comparatorForm.controls.dayConsumptionPercentage.updateValueAndValidity();
    }));
  }

  onDayConsumptionPercentageSubscribe(dayConsumptionPercentageSubscription: Subscription): void {
    dayConsumptionPercentageSubscription = this.electricityComparatorForm.controls.dayConsumptionPercentage.valueChanges.subscribe(value => {
      if (value < 0 || value > 100) {
        alert("Procentul consumului de zi trebuie sa fie intre 0.1 si 100%!");
        this.electricityComparatorForm.controls.dayConsumptionPercentage.setValue("");
      } else {
        this.electricityComparatorForm.controls.nightConsumptionPercentage.setValue(100 - value, { onlySelf: true, emitEvent: false });
      }
    });
  }

  onNightConsumptionPercentageSubscribe(nightConsumptionPercentageSubscription: Subscription): void {
    nightConsumptionPercentageSubscription = this.electricityComparatorForm.controls.nightConsumptionPercentage.valueChanges.subscribe(value => {
      if (value < 0 || value > 100) {
        alert("Procentul consumului de noapte trebuie sa fie intre 0.1 si 100%!");
        this.electricityComparatorForm.controls.nightConsumptionPercentage.setValue("");
      } else {
        this.electricityComparatorForm.controls.dayConsumptionPercentage.setValue(100 - value, { onlySelf: true, emitEvent: false });
      }
    });
  }

  onNaturalGasSupplyComparisonFormSwitch(): void {
    this.title = this.naturalGasSupplyComparison;
    this.isNaturalGasSupplyComparisonForm = true;
    this.isNaturalElectricitySupplyComparisonForm = false;
    this.initGasComparatorForm();
    this.initGasOptions();
    this.getCountiesGaz();
    this.messageError = "";
    this.electricComparatorResults = [];
    this.formSubmitAttempt = false;
  }

  onCheckboxChange(event: any, field: string): void {
    const formArray: FormArray = this.gasComparatorForm.get(field) as FormArray;
    if (event.target.checked) {
      if (event.target.value === 'Oricare') {

        formArray.clear();
        this.gasSelectedConventions = [];
        formArray.push(new FormControl(event.target.value));
        this.gasSelectedConventions.push(event.target.value);
      } else {

        const indexOricare = this.gasSelectedConventions.indexOf('Oricare');
        if (indexOricare !== -1) {
          formArray.removeAt(indexOricare);
          this.gasSelectedConventions.splice(indexOricare, 1);
        }
        formArray.push(new FormControl(event.target.value));
        this.gasSelectedConventions.push(event.target.value);
      }
    } else {
      let index: number = 0;
      formArray.controls.forEach((control: FormControl) => {
        if (control.value == event.target.value) {
          formArray.removeAt(index);
          const removeIndex = this.gasSelectedConventions.indexOf(event.target.value);
          if (removeIndex !== -1) {
            this.gasSelectedConventions.splice(removeIndex, 1);
          }
          return;
        }
        index++;
      });
    }
  }

  onDisplayFieldCss(field: string): any {
    return {
      'input-error': !this.isFieldValid(field) && this.formSubmitAttempt,
    };
  }

  onDisplayMessageError(messageError: string): any {
    return {
      'red': messageError === this.notSelectedAllTheCriteriaMessage,
    };
  }

  onDisplayLabelCss(field: string): any {
    return {
      'red': !this.isFieldValid(field) && this.formSubmitAttempt,
    };
  }

  onConvertToNumber(value: any, decimals?: number): number {
    if (!value) {
      return 0;
    }
    if (typeof value === 'string') {
      value = parseFloat(value.replace(",", ""));
    }
    return decimals ? parseFloat(value.toFixed(decimals)) : value;
  }

  onExpandDetails(gasComparatorResult: any): any {
    gasComparatorResult.isSubRowDisplayed = !gasComparatorResult.isSubRowDisplayed;
  }

  onNaturalElectricitySupplyComparisonFormSwitch(): void {
    this.title = this.naturalElectricitySupplyComparison;
    this.isNaturalElectricitySupplyComparisonForm = true;
    this.isNaturalGasSupplyComparisonForm = false;
    this.initElectricityComparatorForm();
    this.initElectricityOptions();
    this.getCountiesElectricity();
    this.gasComparatorResults = [];
    this.messageError = "";
    this.formSubmitAttempt = false;
  }

  isFieldValid(field: string): boolean {
    return this.comparatorForm.get(field).valid || this.comparatorForm.get(field).disabled;
  }

  onSubmit(denumireFurnizor?: string, el?: HTMLElement): void {
    this.formSubmitAttempt = true;
    if (this.isNaturalGasSupplyComparisonForm) {
      this.isEstimatedMonthlyConsumptionKwhWarningVisible =
        !this.comparatorForm.controls.estimatedMonthlyConsumptionMwh.value ? true : false;
      this.isSupplyPriceWarningVisible =
        !this.comparatorForm.controls.supplyPriceLeiMwh.value ? true : false;
      this.isInvoiceSubscriptionWarningVisible =
        !this.comparatorForm.controls.invoiceSubscriptionLeiZi.value ? true : false;
    }

    if (this.comparatorForm.invalid) {
      this.messageError = this.notSelectedAllTheCriteriaMessage;
      return;
    }

    if (this.isNaturalGasSupplyComparisonForm) {
      let gasComparatorFormData = this.gasComparatorForm.getRawValue();

      let gasConventionInvoice: Array<string> = new Array<string>();
      for (let convention of gasComparatorFormData.convention) {
        if (this.gasConventionTypeValuesMap.get(convention)) {
          gasConventionInvoice.push(this.gasConventionTypeValuesMap.get(convention));
        }
      }

      const comparatorGasDTO: ComparatorGas = {
        finalClientType: gasComparatorFormData.finalClientType.toLocaleLowerCase(),
        connectionMethod: this.connectionModeValuesMap.get(gasComparatorFormData.connectionMethod),
        annualConsumptionCategory: this.consumptionCategoryValuesMap.get(gasComparatorFormData.annualConsumptionCategory),
        county: this.countiesGas.find(x => x.id_judet == gasComparatorFormData.county).nume.toUpperCase(),
        offerDate: this.datepipe.transform(gasComparatorFormData.offerDate, 'dd-MM-yyyy'),
        city: gasComparatorFormData.city,
        unitSupplyPriceType: this.unitPriceTypeValuesMap.get(gasComparatorFormData.unitSupplyPriceType),
        offerType: this.offerTypeGasValuesMap.get(gasComparatorFormData.offerType),
        gasPriceType: this.gasPriceTypeValuesMap.get(gasComparatorFormData.gasPriceType),
        subscription: this.subscriptionValuesMap.get(gasComparatorFormData.subscription),
        paymentTerm: this.paymentTermValuesMap.get(gasComparatorFormData.paymentTerm),
        guarantees: this.guaranteesValuesMap.get(gasComparatorFormData.guarantees),
        convention: gasConventionInvoice,
        estimatedMonthlyConsumptionMwh: gasComparatorFormData.estimatedMonthlyConsumptionMwh,
        estimatedMonthlyConsumptionKwh: gasComparatorFormData.estimatedMonthlyConsumptionKwh,
        supplyPriceLeiMwh: gasComparatorFormData.supplyPriceLeiMwh,
        supplyPriceLeiKwh: gasComparatorFormData.supplyPriceLeiKwh,
        contractDuration: this.gasContractDurationTypeValuesMap.get(gasComparatorFormData.contractDuration),
        invoiceSubscriptionLeiZi: gasComparatorFormData.invoiceSubscriptionLeiZi,
        invoiceFrequency: this.gasInvoiceFrequencyValuesMap.get(gasComparatorFormData.invoiceFrequency)
      };

      this.publicComparatorService.getGasOffers(comparatorGasDTO).subscribe((gasComparatorResults: GasComparatorResult[]) => {
        this.gasComparatorResults = gasComparatorResults.map((gasComparatorResult) => ({
          ...gasComparatorResult,
          isSubRowDisplayed: false
        }));
        if (this.gasComparatorResults.length === 0) {
          this.messageError = this.noResults;
        } else {
          this.messageError = "";
        }
        el?.scrollIntoView();
      });
    } else {
      let electricComparatorFormData = this.electricityComparatorForm.getRawValue();
      const comparatorElectricDTO: ComparatorElectric = {
        clientType: electricComparatorFormData.clientType.toLocaleLowerCase(),
        currentBillConsumption: electricComparatorFormData.currentBillConsumption,
        voltageLevel: this.voltageLevelTypeValuesMap.get(electricComparatorFormData.voltageLevel),
        priceType: this.priceTypeValuesMap.get(electricComparatorFormData.priceType),
        offerDate: this.datepipe.transform(electricComparatorFormData.offerDate, 'dd-MM-yyyy'),
        county: electricComparatorFormData.county,
        offerType: this.offerTypeValuesMap.get(electricComparatorFormData.offerType),
        currentInvoiceValue: electricComparatorFormData.currentInvoiceValue,
        fixedComponentOffers: this.fixedComponentOffersValuesMap.get(electricComparatorFormData.fixedComponentOffers),
        productType: this.productTypeValuesMap.get(electricComparatorFormData.productType),
        convention: this.electricConventionTypeValuesMap.get(electricComparatorFormData.convention),
        counterReadingFrequency: this.counterReadingFrequencyTypeValuesMap.get(electricComparatorFormData.counterReadingFrequency),
        renewableEnergy: this.renewableEnergyTypeValuesMap.get(electricComparatorFormData.renewableEnergy),
        invoiceFrequency: this.electricInvoiceFrequencyValuesMap.get(electricComparatorFormData.invoiceFrequency),
        contractDuration: this.contractDurationTypeValuesMap.get(electricComparatorFormData.contractDuration),
        denumireFurnizor: denumireFurnizor,
        dayConsumptionPercentage: electricComparatorFormData.dayConsumptionPercentage,
        nightConsumptionPercentage: electricComparatorFormData.nightConsumptionPercentage,
        zoneId: this.zoneId
      }
      this.subscriptions.push(this.publicComparatorService.getElectricOffers(comparatorElectricDTO).subscribe((electricComparatorResult: ElectricComparatorResult[]) => {
        this.electricComparatorResults = electricComparatorResult.map((electricComparatorResult: ElectricComparatorResult) => ({
          ...electricComparatorResult,
          isSubRowDisplayed: false
        }));

        if (this.electricComparatorResults.length === 0) {
          this.messageError = this.noResults;
        } else {
          this.messageError = "";
        }
        el?.scrollIntoView();
      }));
    }
  }

  search(denumireFurnizor: string): void {
    this.onSubmit(denumireFurnizor);
  }

  get mandatoryCriteriaInputs(): any {
    return this.isNaturalGasSupplyComparisonForm ? this.naturalGasSupplyMandatoryCriteriaInputs : this.electricitySupplyMandatoryCriteriaInputs;
  }

  get additionalCriteriaInputs(): any {
    return this.isNaturalGasSupplyComparisonForm ? this.naturalGasSupplyAdditionalCriteriaInputs : this.electricitySupplyAdditionalCriteriaInputs;
  }

  get userGuideLink(): string {
    return this.isNaturalGasSupplyComparisonForm ?
      "https://anre.ro/wp-content/uploads/2025/01/Ghid-de-utilizare-al-comparatorului-de-preturi-pentru-GAZE-NATURALE.pdf" :
      "https://anre.ro/wp-content/uploads/2025/01/Ghid-de-utilizare-al-comparatorului-de-preturi-pentru-ENERGIE-ELECTRICA.pdf";
  }

  get userTutorialLink(): string {
    return this.isNaturalGasSupplyComparisonForm ?
      "https://www.youtube.com/watch?v=VTnqIY_dJNM" :
      "https://www.youtube.com/watch?v=Th0jjiX2iMY";
  }

  get naturalGasSupplyComparison(): string {
    return NATURAL_GAS_SUPPLY_COMPARISON;
  }

  get naturalElectricitySupplyComparison(): string {
    return NATURAL_ELECTRICITY_SUPPLY_COMPARISON;
  }

  get comparatorForm(): FormGroup {
    return this.isNaturalGasSupplyComparisonForm ? this.gasComparatorForm : this.electricityComparatorForm;
  }

  get applicationUserGuide(): string {
    return this.isNaturalGasSupplyComparisonForm ?
      "Ghidul de utilizare a aplicației Comparator oferte-tip de furnizare a gazelor naturale" :
      "Ghidul de utilizare a aplicației Comparator oferte-tip de furnizare a energiei electrice";
  }

  get applicationTutorial(): string {
    return this.isNaturalGasSupplyComparisonForm ?
      "Tutorialul de utilizare a aplicației Comparator oferte-tip de furnizare a gazelor naturale" :
      "Tutorialul de utilizare a aplicației Comparator oferte-tip de furnizare a energiei electrice";
  }

  get naturalGasSupplyMandatoryCriteriaInputs(): typeof NaturalGasSupplyMandatoryCriteriaEnum {
    return NaturalGasSupplyMandatoryCriteriaEnum;
  }

  get electricitySupplyMandatoryCriteriaInputs(): typeof ElectricitySupplyMandatoryCriteriaEnum {
    return ElectricitySupplyMandatoryCriteriaEnum;
  }

  get naturalGasSupplyAdditionalCriteriaInputs(): typeof NaturalGasSupplyAdditionalCriteriaEnum {
    return NaturalGasSupplyAdditionalCriteriaEnum;
  }

  get electricitySupplyAdditionalCriteriaInputs(): typeof ElectricitySupplyAdditionalCriteriaEnum {
    return ElectricitySupplyAdditionalCriteriaEnum;
  }

  get naturalGasSupplyComparisonInformationCriteriaInputs(): typeof NaturalGasSupplyComparisonInformationCriteriaEnum {
    return NaturalGasSupplyComparisonInformationCriteriaEnum;
  }

  get supplyPricePlaceholder(): string {
    return "Pret de furnizare actual";
  }

  get invoiceSubscriptionPlaceholder(): string {
    return "Introduceti valoare 0 daca in prezent nu aveti abonament";
  }

  get estimatedMonthlyConsumtionPlaceholder(): string {
    return "Consum estimat";
  }

  get informationCriteriaWarning(): string {
    return "Vă recomandam să completați si acest câmp pentru a obține informaţii comparative despre preţ și costuri in tabelul de rezultate";
  }

  get footerTextResults(): string {
    let comparatorType = this.isNaturalGasSupplyComparisonForm ? "gazelor naturale" : "energiei electrice";
    return `Comparator oferte-tip de furnizare a ${comparatorType} are un caracter exclusiv informativ.<br>` +
      (this.isNaturalGasSupplyComparisonForm ? `Acurateţea rezultatelor căutării depinde de informaţiile introduse de furnizorii de gaze naturale în baza de date a Comparatorului, corectitudinea lor fiind în exclusivitate responsabilitatea acestora.` :
        `Acurateţea rezultatelor căutării depinde de informaţiile introduse de furnizorii de energie electrica în baza de date a Comparatorului, corectitudinea lor fiind în exclusivitate responsabilitatea acestora.`) +
      `<br> Prin folosirea Comparatorului, utilizatorii confirmă luarea la cunoştinţă, înţelegerea şi acceptarea: <a href=\"https://arhiva.anre.ro/ro/comparator-tarife/termeni-si-conditii-de-utilizare\" target=\"_blank\">Termenilor şi condiţiilor</a> şi a informaţiilor din secţiunea <a href=\"https://arhiva.anre.ro/ro/comparator-tarife/cum-functioneaza\" target=\"_blank\">Cum functioneaza</a> `;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      for (const subscription of this.subscriptions) {
        if (subscription) {
          subscription.unsubscribe();
        }
      }
    }
  }

}
